// extracted by mini-css-extract-plugin
module.exports = {"inputSearch":"SearchCompo_inputSearch__ZdLlb","input-elevated":"SearchCompo_input-elevated__2__6U"};